import { JSX, ReactNode, createContext, useContext, useState } from 'react';

type AccountCreationCtx = {
  accountCreationEnabled: boolean;
  setAccountCreationEnabled: (accountCreationEnabled: boolean) => void;
};

export const AccountCreationContext = createContext<AccountCreationCtx>({
  accountCreationEnabled: false,
  setAccountCreationEnabled: () => {},
});

export const AccountCreationProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [accountCreationEnabled, setAccountCreationEnabled] = useState<boolean>(false);

  const handleSetAccountCreationEnabled = (accountCreationEnabled: boolean) => {
    setAccountCreationEnabled(accountCreationEnabled);
  };

  return (
    <AccountCreationContext.Provider
      value={{ accountCreationEnabled, setAccountCreationEnabled: handleSetAccountCreationEnabled }}
    >
      {children}
    </AccountCreationContext.Provider>
  );
};

export const useAccountCreation = (): AccountCreationCtx => useContext(AccountCreationContext);
